/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "./css/Integrations.css";
import Fcontact from "../Shared/Fcontact";
import { Helmet } from "react-helmet";
import Aos from "aos";
import Modal from "react-bootstrap/Modal";
import intBannerImg from "../../assets/imgs/integrations-banner.webp";
import CommunicationImg from "../../assets/imgs/communication-img.webp";
import IntOutlook from "../../assets/imgs/int-outlook.webp";
import IntTeams from "../../assets/imgs/int-teams.webp";
import Sharpoint from "../../assets/imgs/sharpoint.webp";
import MsPlanner from "../../assets/imgs/ms-planner.webp";
import MarketingImg from "../../assets/imgs/marketing-img.webp";
import Stripe from "../../assets/imgs/stripe.jpg";
import Paypal from "../../assets/imgs/paypal.jpg";

const Integrations = () => {
  const [isFormLoaded, isSetFormLoaded] = useState(false);
  const [show, setShow] = useState(false);
  const [policy, setPolicy] = useState(false);
  const handleClose = () => {
    setPolicy(false);
    setShow(false);
  };
  const handleShow = () => {
    setPolicy(true);
    setShow(true);
  };
  useEffect(() => {
    window.addEventListener("load", Aos.refresh);
    isSetFormLoaded(true);

    Aos.init({
      once: false,
    });
  });

  useEffect(() => {
    const violation = document.getElementById("top-menu");
    window.scrollTo({
      top: violation.offsetTop,
      // behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Right Cause Integrations | CRM Integration</title>
        <meta name="keywords" content="" />
        <meta
          name="description"
          content="Connect your favorite tool to Right Cause CRM for a streamlined workflow. Explore our comprehensive list of integrations and save time on your daily tasks."
        />
      </Helmet>
      <header>
        <div class="container-fluid">
          <div class="banner-wrap">
            <div class="banner-slider">
              <div class="banner-slide g-banner">
                <div class="container">
                  <div class="sliderContent">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="slideTxt">
                          <div class="darkTxt g-darkTxt">
                            Connect Your Tools
                            <br />
                            with Right Cause
                            <br />
                            Integration
                          </div>
                          <p>
                            We’re here to make the integration process simple,
                            so you can focus on what truly matters—your cause.
                          </p>
                          <div class="homesliderbtn">
                            {" "}
                            <a
                              href="#getStrated"
                              class="rc-primary-btn rc-large-btn rc-btn"
                              tabindex="0"
                              aria-label="Get a Demo Button"
                            >
                              Get started for free <i class="icon-arrow"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="g-mask">
                          <img
                            class="svg-normal-mask"
                            alt="A Cloud-based charity-focused Nonprofit Software"
                            src={intBannerImg}
                            width="1000"
                            height="667"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main>
        <section class="acceleratorCrm-Section integration-cc">
          <div class="container">
            <div class="row align-items-center text-center">
              <div
                class="col-md-12 col-lg-10 offset-lg-1 mt-xs-3"
                data-aos="zoom-in"
              >
                <h1 class="h1">Software Integrations</h1>
                <p>
                  We understand the importance of using various tools to drive
                  your mission forward. That’s why we offer seamless Right Cause
                  Integration with industry-leading software, including Dynamics
                  CRM Integration.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="communication-section">
          <div class="container">
            <div class="row">
              <div class="col-md-12 mb-4 text-center">
                <div class="headingThree">Communication & Collaboration</div>
              </div>
            </div>
            <div class="row">
              {/* <div class="col-md-6">
                                <img alt="Communication" src={CommunicationImg} width="596" height="723" />
                            </div> */}
              <div class="col-md-12">
                <div class="row">
                  <div
                    class="col-md-6"
                    data-aos="zoom-in"
                    data-aos-duration="1100"
                  >
                    <div class="card">
                      <div class="tech_icon">
                        <img
                          alt="Outlook"
                          src={IntOutlook}
                          width="73"
                          height="73"
                        />
                      </div>
                      <div class="card-body">
                        <p class="card-title">Microsoft Outlook</p>
                        <p class="card-text">
                          Keep your communications organized and in sync with
                          your fundraising and grant management efforts.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    data-aos="zoom-in"
                    data-aos-duration="1200"
                  >
                    <div class="card">
                      <div class="tech_icon">
                        <img
                          alt="Teams"
                          src={IntTeams}
                          width="73"
                          height="73"
                        />
                      </div>
                      <div class="card-body">
                        <p class="card-title">Microsoft Teams</p>
                        <p class="card-text">
                          Enhance teamwork with real-time collaboration directly
                          within Right Cause.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    data-aos="zoom-in"
                    data-aos-duration="1300"
                  >
                    <div class="card">
                      <div class="tech_icon">
                        <img
                          alt="Teams"
                          src={Sharpoint}
                          width="73"
                          height="73"
                        />
                      </div>
                      <div class="card-body">
                        <p class="card-title">Microsoft SharePoint</p>
                        <p class="card-text">
                          Manage and share documents effortlessly, while keeping
                          them connected to your nonprofit activities.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    data-aos="zoom-in"
                    data-aos-duration="1400"
                  >
                    <div class="card">
                      <div class="tech_icon">
                        <img
                          alt="MS Planner"
                          src={MsPlanner}
                          width="73"
                          height="73"
                        />
                      </div>
                      <div class="card-body">
                        <p class="card-title">Microsoft Planner</p>
                        <p class="card-text">
                          Organize tasks and projects efficiently within your
                          team.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="valueProposition-section">
          <div class="container">
            <div class="row">
              <div class="col-md-12 mb-5 text-center">
                <div class="headingThree">Marketing & Engagement</div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-md-6 col-lg-6 mt-xs-3">
                <div class="keyList-item">
                  <div class="row">
                    <div
                      class="col-md-12 mb-4 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1000"
                    >
                      <div class="keyList_icon">
                        <span class="icon-mailchimp"></span>
                      </div>
                      <div class="keyList_content">
                        <strong class="h5">MailChimp</strong>
                        <p>
                          Automate your email marketing campaigns to engage
                          donors effectively.
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-md-12 mb-4 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1100"
                    >
                      <div class="keyList_icon">
                        <span class="icon-facebook"></span>
                      </div>
                      <div class="keyList_content">
                        <strong class="h5">Facebook</strong>
                        <p>
                          Connect with your audience and promote your cause on
                          social media.
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-md-12 mb-4 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1200"
                    >
                      <div class="keyList_icon">
                        <span class="icon-insta"></span>
                      </div>
                      <div class="keyList_content">
                        <strong class="h5">Instagram</strong>
                        <p>
                          Share your mission visually and connect with
                          supporters.
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-md-12 mb-4 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1300"
                    >
                      <div class="keyList_icon">
                        <span class="icon-twitter-new-logo"></span>
                      </div>
                      <div class="keyList_content">
                        <strong class="h5">Twitter/X</strong>
                        <p>
                          Engage with your community in real-time and share
                          updates.
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-md-12 mb-4 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1400"
                    >
                      <div class="keyList_icon">
                        <span class="icon-link"></span>
                      </div>
                      <div class="keyList_content">
                        <strong class="h5">LinkedIn</strong>
                        <p>
                          Build professional relationships and promote your
                          nonprofit.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-6 aos-init" data-aos="zoom-out-right">
                <img
                  alt="Marketing & Engagement"
                  src={MarketingImg}
                  width="675"
                  height="475"
                />
              </div>
            </div>
          </div>
        </section>
        <section class="accounting-section integration-acc-cc">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="finance-content-one">
                  <div class="row">
                    <div class="col-md-12 mb-5 text-center">
                      <div class="headingThree">Accounting & Finance</div>
                    </div>
                  </div>
                  <div class="row m-0">
                    <div
                      class="col-md-6 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1100"
                    >
                      <div class="keyList_icon">
                        <span class="icon-quickbooks"></span>
                      </div>
                      <div class="keyList_content">
                        <strong class="h5 ">QuickBooks</strong>
                        <p>
                          Connect with your audience and promote your cause on
                          social media.
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-md-6 d-flex align-items-center aos-init "
                      data-aos="fade-left"
                      data-aos-duration="1100 "
                    >
                      <div class="keyList_icon">
                        <span class="icon-bi"></span>
                      </div>
                      <div class="keyList_content">
                        <strong class="h5">RazorPay</strong>
                        <p>
                          Simplify payment processing with our RazorPay
                          integration.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-4">
                <div class="finance-content-two">
                  <div class="row m-0">
                    <div class="col-md-12 d-flex align-items-center">
                      <div class="keyList_icon invisible"></div>
                      <div class="keyList_content">
                        <div class="headingThree">
                          Fundraising & Donor Management
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1100"
                    >
                      <div class="keyList_icon ">
                        <span class="icon-buttergive "></span>
                      </div>
                      <div class="keyList_content ">
                        <strong class="h5 ">GiveButter</strong>
                        <p>
                          Streamline donation processes and enhance your
                          fundraising efforts through our integration with
                          GiveButter.
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex align-items-center aos-init "
                      data-aos="fade-left"
                      data-aos-duration="1100"
                    >
                      <div class="keyList_icon invisible"></div>
                      <div class="keyList_content">
                        <div class="headingThree">CRM</div>
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1100"
                    >
                      <div class="keyList_icon ">
                        <span class="icon-crm "></span>
                      </div>
                      <div class="keyList_content ">
                        <strong class="h5 ">Dynamics CRM Integration</strong>
                        <p>
                          Seamlessly connect your existing CRM data with Right
                          Cause. Manage your donor relationships, track
                          interactions, and automate workflows—all within a
                          unified platform.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-4 ">
                <div class="finance-content-two part-2 ">
                  <div class="row m-0 ">
                    <div
                      class="col-md-12 d-flex align-items-center aos-init "
                      data-aos="fade-left"
                      data-aos-duration="1100 "
                    >
                      <div class="keyList_icon invisible"></div>
                      <div class="keyList_content">
                        <div class="headingThree">
                          Data Visualization & Reporting
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1100"
                    >
                      <div class="keyList_icon ">
                        <span class="icon-powerbi-1 "></span>
                      </div>
                      <div class="keyList_content ">
                        <strong class="h5 ">Power BI</strong>
                        <p>
                          Unlock advanced analytics and customizable dashboards
                          with Power BI Integration to gain deeper insights into
                          your nonprofit’s performance.
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex align-items-center aos-init "
                      data-aos="fade-left"
                      data-aos-duration="1100 "
                    >
                      <div class="keyList_icon invisible"></div>
                      <div class="keyList_content">
                        <div class="headingThree">Automation & Integration</div>
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex align-items-center aos-init"
                      data-aos="fade-left"
                      data-aos-duration="1100"
                    >
                      <div class="keyList_icon ">
                        <span class="icon-zaiper "></span>
                      </div>
                      <div class="keyList_content ">
                        <strong class="h5 ">Zaiper</strong>
                        <p>
                          Automate workflows between your apps and Right Cause
                          for enhanced efficiency.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="container ">
            <div class="row ">
              <div class="col-md-12 mb-5 text-center ">
                <div class="headingThree ">Accounting & Finance</div>
              </div>
            </div>
            <div class="row ">
              <div class="col-md-6 col-lg-6 mt-xs-3 ">
                <div class="keyList-item ">
                  <div class="row ">
                    <div
                      class="col-md-12 mb-4 d-flex align-items-center aos-init "
                      data-aos="fade-left"
                      data-aos-duration="1000 "
                    >
                      <div class="keyList_icon ">
                        <span class="icon-warrior "></span>
                      </div>
                      <div class="keyList_content ">
                        <strong class="h5 ">Merchant Warrior</strong>
                        <p>
                          Integrate secure payment processing tailored to your
                          needs.
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-md-12 mb-4 d-flex align-items-center aos-init "
                      data-aos="fade-left"
                      data-aos-duration="1100 "
                    >
                      <div class="keyList_icon ">
                        <span class="icon-omni "></span>
                      </div>
                      <div class="keyList_content ">
                        <strong class="h5 ">
                          Omnichannels and External Websites
                        </strong>
                        <p>Engage with donors across multiple platforms.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-6 mt-xs-3 ">
                <div class="keyList-item ">
                  <div class="row ">
                    <div
                      class="col-md-12 mb-4 d-flex align-items-center aos-init "
                      data-aos="fade-left"
                      data-aos-duration="1000 "
                    >
                      <div class="keyList_icon ">
                        <span class="icon-canvasApp "></span>
                      </div>
                      <div class="keyList_content ">
                        <strong class="h5 ">Canvas Apps</strong>
                        <p>
                          Create custom applications to enhance your workflow.
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-md-12 mb-4 d-flex align-items-center aos-init "
                      data-aos="fade-left"
                      data-aos-duration="1100 "
                    >
                      <div class="keyList_icon ">
                        <span class="icon-chat "></span>
                      </div>
                      <div class="keyList_content ">
                        <strong class="h5 ">Power Virtual Agent (PVA)</strong>
                        <p>
                          Build chatbots and automate customer service
                          interactions.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2 text-center">
                <a
                  href="#getStrated"
                  class="rc-primary-btn rc-large-btn rc-btn mt-xl-3 "
                  tabindex="0 "
                  aria-label="Explore
                                            Right Cause Solution Integration "
                >
                  Explore Right Cause Solution Integration
                  <i class="icon-arrow "></i>
                </a>
              </div>
            </div>
          </div>
        </section>
        <section class="paymentProcessor-section pps-cc mt-5">
          <div class="container">
            <div class="row">
              <div class="col-md-12 text-center mb-5">
                <div class="headingThree ">Payment Processor Integrations</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <p>
                  Connect with the best payment processors on the market. Right
                  Cause has partnered with Stripe and PayPal to offer safe,
                  secure payment processing.
                </p>
                <p>
                  Whether you’re accepting donations or managing payments, our
                  CRM Integration ensures that your financial transactions are
                  handled smoothly and securely.
                </p>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <img alt="Stripe" src={Stripe} width="252" height="150" />
                  <img alt="Paypal" src={Paypal} width="252" height="150" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="our_purposeSection g-cta integration-op-gcta-cc ">
          <div class="container ">
            <div class="row justify-content-center ">
              <div class="col-md-10 text-center ">
                <div class="largeTxt ">
                  <h2 class="h2">Enroll for 7-day Free Trial</h2>
                  <div>
                    Try Right Cause risk-free.
                    <br />
                    No credit card required.
                  </div>
                  <a
                    href="/pricing-plan"
                    class="greenBtn"
                    tabindex="0"
                    aria-label="Request Demo Button"
                  >
                    View Pricing
                  </a>
                  &nbsp;
                  <a
                    href="#getStrated"
                    class="greenBtn"
                    tabindex="0"
                    aria-label="Request Demo Button"
                  >
                    Try for Free
                  </a>
                  {/* <h2 class="h2 border-none mt-5">All accounts get their first 30 days free!</h2>
                                    <div class="text-center aLink">
                                        <a href="https://www.beyondkey.com/privacy-policy" target="_blank">Privacy Policy</a> <a href="https://www.beyondintranet.com/terms-of-use" target="_blank">Terms of Service</a>
                                    </div> */}
                </div>
              </div>
              <div class="col-md-12 text-center mt-5">
                <p>
                  To set up a Right Cause Integration with any of the services
                  listed above, you will first need accounts with those
                  services.
                  <br />
                  While Right Cause does not charge to integrate with these
                  tools, please note that these third parties may require a paid
                  account.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div>
        <Modal
          size="lg"
          show={show}
          onHide={handleClose}
          className="modal_getStartedForm"
        >
          <Modal.Header closeButton></Modal.Header>
          <Fcontact policy={policy} onSubmit={handleClose} />
        </Modal>
      </div>
    </>
  );
};

export default Integrations;
